import { colors } from "@/styles/colors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(({
	button: {
		background: colors.gray[50],
		color: colors.gray[800],
		fontWeight: 500,
		boxShadow: "none",
		"&:hover": {
			background: colors.gray[100],
			color: colors.gray[700],
			boxShadow: "none"
		}
	},
	copyButtonText: {
		maxWidth: "220px",
		overflow: "hidden",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis"
	}
}))

export default useStyles
